"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = userSaga;
var _effects = require("redux-saga/effects");
var _services = require("../../../../services");
var _user = require("./user.action");
var _user2 = require("./user.constant");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _marked = /*#__PURE__*/_regeneratorRuntime().mark(userAdminDetails),
  _marked2 = /*#__PURE__*/_regeneratorRuntime().mark(userSaga);
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; } // @flow
/**
 * Send mail
 * @param payload
 * @returns api response
 * @description this function used send mail for new account.
 */
function userSendEmail(_ref) {
  var payload = _ref.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _response$data, response, _response$data2;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.call)(_services.userSendEmailApi, payload);
        case 3:
          response = _context.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.code) === 202)) {
            _context.next = 9;
            break;
          }
          _context.next = 7;
          return (0, _effects.put)((0, _user.userSuccess)(_user2.actionTypes.SEND_EMAIL, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context.next = 11;
          break;
        case 9:
          _context.next = 11;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.SEND_EMAIL, response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.message));
        case 11:
          _context.next = 17;
          break;
        case 13:
          _context.prev = 13;
          _context.t0 = _context["catch"](0);
          _context.next = 17;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.SEND_EMAIL, _context.t0));
        case 17:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 13]]);
  })();
}

/* add user
 * @param payload
 * @returns api response
 * @description this function used to add user.
 */
function userAdd(_ref2) {
  var payload = _ref2.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var _response$data3, response, _response$data4, _response$data5;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.call)(_services.userAddApi, payload);
        case 3:
          response = _context2.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.code) === 201)) {
            _context2.next = 9;
            break;
          }
          _context2.next = 7;
          return (0, _effects.put)((0, _user.userSuccess)(_user2.actionTypes.ADD, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context2.next = 11;
          break;
        case 9:
          _context2.next = 11;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.ADD, (response === null || response === void 0 ? void 0 : (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.data) || (response === null || response === void 0 ? void 0 : (_response$data5 = response.data) === null || _response$data5 === void 0 ? void 0 : _response$data5.message)));
        case 11:
          _context2.next = 17;
          break;
        case 13:
          _context2.prev = 13;
          _context2.t0 = _context2["catch"](0);
          _context2.next = 17;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.ADD, _context2.t0));
        case 17:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 13]]);
  })();
}

/**
 * fetch
 * @param payload
 * @returns api response
 * @description this function used to get user.
 */
function userFetch(_ref3) {
  var payload = _ref3.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var _response$data6, response, _response$data7;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return (0, _effects.call)(_services.userFetchApi, payload);
        case 3:
          response = _context3.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data6 = response.data) === null || _response$data6 === void 0 ? void 0 : _response$data6.code) === 200)) {
            _context3.next = 9;
            break;
          }
          _context3.next = 7;
          return (0, _effects.put)((0, _user.userSuccess)(_user2.actionTypes.FETCH, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context3.next = 11;
          break;
        case 9:
          _context3.next = 11;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.FETCH, response === null || response === void 0 ? void 0 : (_response$data7 = response.data) === null || _response$data7 === void 0 ? void 0 : _response$data7.message));
        case 11:
          _context3.next = 17;
          break;
        case 13:
          _context3.prev = 13;
          _context3.t0 = _context3["catch"](0);
          _context3.next = 17;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.FETCH, _context3.t0));
        case 17:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 13]]);
  })();
}

/**
 * admin details
 * @param payload
 * @returns api response
 * @description this function used to get admin details.
 */
function userAdminDetails() {
  var _response$data8, response;
  return _regeneratorRuntime().wrap(function userAdminDetails$(_context4) {
    while (1) switch (_context4.prev = _context4.next) {
      case 0:
        _context4.prev = 0;
        _context4.next = 3;
        return (0, _effects.call)(_services.userAdminApi);
      case 3:
        response = _context4.sent;
        if (!((response === null || response === void 0 ? void 0 : (_response$data8 = response.data) === null || _response$data8 === void 0 ? void 0 : _response$data8.code) === 200)) {
          _context4.next = 9;
          break;
        }
        _context4.next = 7;
        return (0, _effects.put)((0, _user.userSuccess)(_user2.actionTypes.USER_ADMIN, response === null || response === void 0 ? void 0 : response.data));
      case 7:
        _context4.next = 11;
        break;
      case 9:
        _context4.next = 11;
        return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.USER_ADMIN, response === null || response === void 0 ? void 0 : response.data));
      case 11:
        _context4.next = 17;
        break;
      case 13:
        _context4.prev = 13;
        _context4.t0 = _context4["catch"](0);
        _context4.next = 17;
        return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.USER_ADMIN, _context4.t0));
      case 17:
      case "end":
        return _context4.stop();
    }
  }, _marked, null, [[0, 13]]);
}

/**
 * details
 * @param payload
 * @returns api response
 * @description this function used to get details.
 */
function userDetails(_ref4) {
  var payload = _ref4.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var _response$data9, response, _response$data10;
    return _regeneratorRuntime().wrap(function _callee4$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _context5.next = 3;
          return (0, _effects.call)(_services.userDetailsApi, payload);
        case 3:
          response = _context5.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data9 = response.data) === null || _response$data9 === void 0 ? void 0 : _response$data9.code) === 200)) {
            _context5.next = 9;
            break;
          }
          _context5.next = 7;
          return (0, _effects.put)((0, _user.userSuccess)(_user2.actionTypes.DETAILS, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context5.next = 11;
          break;
        case 9:
          _context5.next = 11;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.DETAILS, response === null || response === void 0 ? void 0 : (_response$data10 = response.data) === null || _response$data10 === void 0 ? void 0 : _response$data10.message));
        case 11:
          _context5.next = 17;
          break;
        case 13:
          _context5.prev = 13;
          _context5.t0 = _context5["catch"](0);
          _context5.next = 17;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.DETAILS, _context5.t0));
        case 17:
        case "end":
          return _context5.stop();
      }
    }, _callee4, null, [[0, 13]]);
  })();
}

/* list
 * @param payload
 * @returns api response
 * @description this function used to get user's list.
 */
function userList(_ref5) {
  var payload = _ref5.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var _payload, _payload$isActive, _payload6, _payload6$roleIdList, _response$data11, filter, _payload2, _payload2$isActive, _payload2$isActive$fi, _payload4, _payload4$isActive, _payload4$isActive$fi, _payload3, _payload3$isActive, _payload5, _payload5$isActive, isActive, response, _response$data12, _response$data13;
    return _regeneratorRuntime().wrap(function _callee5$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          // Start isActive field adjustment as per api required
          filter = {};
          if (((_payload = payload) === null || _payload === void 0 ? void 0 : (_payload$isActive = _payload.isActive) === null || _payload$isActive === void 0 ? void 0 : _payload$isActive.length) > 0) {
            if (((_payload2 = payload) === null || _payload2 === void 0 ? void 0 : (_payload2$isActive = _payload2.isActive) === null || _payload2$isActive === void 0 ? void 0 : (_payload2$isActive$fi = _payload2$isActive.filter(function (el) {
              return el === true || el === false;
            })) === null || _payload2$isActive$fi === void 0 ? void 0 : _payload2$isActive$fi.length) === 1) {
              filter["isActive"] = (_payload3 = payload) === null || _payload3 === void 0 ? void 0 : (_payload3$isActive = _payload3.isActive) === null || _payload3$isActive === void 0 ? void 0 : _payload3$isActive.filter(function (el) {
                return el === true || el === false;
              });
            }
            if (((_payload4 = payload) === null || _payload4 === void 0 ? void 0 : (_payload4$isActive = _payload4.isActive) === null || _payload4$isActive === void 0 ? void 0 : (_payload4$isActive$fi = _payload4$isActive.filter(function (el) {
              return el === 0 || el === 1;
            })) === null || _payload4$isActive$fi === void 0 ? void 0 : _payload4$isActive$fi.length) === 1) {
              isActive = (_payload5 = payload) === null || _payload5 === void 0 ? void 0 : (_payload5$isActive = _payload5.isActive) === null || _payload5$isActive === void 0 ? void 0 : _payload5$isActive.filter(function (el) {
                return el === 0 || el === 1;
              })[0];
              filter["loginStatus"] = isActive ? true : false;
            }
            delete payload.isActive;
            payload = _objectSpread(_objectSpread({}, filter), payload);
          }
          // End isActive field adjustment

          if ((_payload6 = payload) !== null && _payload6 !== void 0 && (_payload6$roleIdList = _payload6.roleIdList) !== null && _payload6$roleIdList !== void 0 && _payload6$roleIdList.includes(4)) {
            payload.roleIdList.push(3);
          }
          _context6.next = 6;
          return (0, _effects.call)(_services.userListApi, payload);
        case 6:
          response = _context6.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data11 = response.data) === null || _response$data11 === void 0 ? void 0 : _response$data11.code) === 200)) {
            _context6.next = 12;
            break;
          }
          _context6.next = 10;
          return (0, _effects.put)((0, _user.userSuccess)(_user2.actionTypes.LIST, response === null || response === void 0 ? void 0 : (_response$data12 = response.data) === null || _response$data12 === void 0 ? void 0 : _response$data12.data));
        case 10:
          _context6.next = 14;
          break;
        case 12:
          _context6.next = 14;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.LIST, response === null || response === void 0 ? void 0 : (_response$data13 = response.data) === null || _response$data13 === void 0 ? void 0 : _response$data13.message));
        case 14:
          _context6.next = 20;
          break;
        case 16:
          _context6.prev = 16;
          _context6.t0 = _context6["catch"](0);
          _context6.next = 20;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.LIST, _context6.t0));
        case 20:
        case "end":
          return _context6.stop();
      }
    }, _callee5, null, [[0, 16]]);
  })();
}

/* list
 * @param payload
 * @returns api response
 * @description this function used to get user's list.
 */
function userListTransfer(_ref6) {
  var payload = _ref6.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
    var _response$data14, response, _response$data15, _response$data16;
    return _regeneratorRuntime().wrap(function _callee6$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _context7.next = 3;
          return (0, _effects.call)(_services.userListApi, payload);
        case 3:
          response = _context7.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data14 = response.data) === null || _response$data14 === void 0 ? void 0 : _response$data14.code) === 200)) {
            _context7.next = 9;
            break;
          }
          _context7.next = 7;
          return (0, _effects.put)((0, _user.userSuccess)(_user2.actionTypes.LIST_TRANSFER, response === null || response === void 0 ? void 0 : (_response$data15 = response.data) === null || _response$data15 === void 0 ? void 0 : _response$data15.data));
        case 7:
          _context7.next = 11;
          break;
        case 9:
          _context7.next = 11;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.LIST_TRANSFER, response === null || response === void 0 ? void 0 : (_response$data16 = response.data) === null || _response$data16 === void 0 ? void 0 : _response$data16.message));
        case 11:
          _context7.next = 17;
          break;
        case 13:
          _context7.prev = 13;
          _context7.t0 = _context7["catch"](0);
          _context7.next = 17;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.LIST_TRANSFER, _context7.t0));
        case 17:
        case "end":
          return _context7.stop();
      }
    }, _callee6, null, [[0, 13]]);
  })();
}

/* list
 * @param payload
 * @returns api response
 * @description this function used to get user's list.
 */
function userUnpagedList(_ref7) {
  var payload = _ref7.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
    var _response$data17, response, _response$data18, _response$data19;
    return _regeneratorRuntime().wrap(function _callee7$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.prev = 0;
          _context8.next = 3;
          return (0, _effects.call)(_services.userListApi, payload);
        case 3:
          response = _context8.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data17 = response.data) === null || _response$data17 === void 0 ? void 0 : _response$data17.code) === 200)) {
            _context8.next = 9;
            break;
          }
          _context8.next = 7;
          return (0, _effects.put)((0, _user.userSuccess)(_user2.actionTypes.LIST_UNPAGED, response === null || response === void 0 ? void 0 : (_response$data18 = response.data) === null || _response$data18 === void 0 ? void 0 : _response$data18.data));
        case 7:
          _context8.next = 11;
          break;
        case 9:
          _context8.next = 11;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.LIST_UNPAGED, response === null || response === void 0 ? void 0 : (_response$data19 = response.data) === null || _response$data19 === void 0 ? void 0 : _response$data19.message));
        case 11:
          _context8.next = 17;
          break;
        case 13:
          _context8.prev = 13;
          _context8.t0 = _context8["catch"](0);
          _context8.next = 17;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.LIST_UNPAGED, _context8.t0));
        case 17:
        case "end":
          return _context8.stop();
      }
    }, _callee7, null, [[0, 13]]);
  })();
}

/* list of deleted by user
 * @param payload
 * @returns api response
 * @description this function used to get user's deleted by list.
 */
function userDeletedByList(_ref8) {
  var payload = _ref8.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
    var _response$data20, response, _response$data21, _response$data22;
    return _regeneratorRuntime().wrap(function _callee8$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _context9.prev = 0;
          _context9.next = 3;
          return (0, _effects.call)(_services.userDeletedByListApi, payload);
        case 3:
          response = _context9.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data20 = response.data) === null || _response$data20 === void 0 ? void 0 : _response$data20.code) === 200)) {
            _context9.next = 9;
            break;
          }
          _context9.next = 7;
          return (0, _effects.put)((0, _user.userSuccess)(_user2.actionTypes.LIST_DELETED_BY_USER, response === null || response === void 0 ? void 0 : (_response$data21 = response.data) === null || _response$data21 === void 0 ? void 0 : _response$data21.data));
        case 7:
          _context9.next = 11;
          break;
        case 9:
          _context9.next = 11;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.LIST_DELETED_BY_USER, response === null || response === void 0 ? void 0 : (_response$data22 = response.data) === null || _response$data22 === void 0 ? void 0 : _response$data22.message));
        case 11:
          _context9.next = 17;
          break;
        case 13:
          _context9.prev = 13;
          _context9.t0 = _context9["catch"](0);
          _context9.next = 17;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.LIST_DELETED_BY_USER, _context9.t0));
        case 17:
        case "end":
          return _context9.stop();
      }
    }, _callee8, null, [[0, 13]]);
  })();
}

/* list
 * @param payload
 * @returns api response
 * @description this function used to get user's list.
 */
function brandUserList(_ref9) {
  var payload = _ref9.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
    var _response$data23, response, _response$data24, _response$data25;
    return _regeneratorRuntime().wrap(function _callee9$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          _context10.prev = 0;
          _context10.next = 3;
          return (0, _effects.call)(_services.brandUserListApi, payload);
        case 3:
          response = _context10.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data23 = response.data) === null || _response$data23 === void 0 ? void 0 : _response$data23.code) === 200)) {
            _context10.next = 9;
            break;
          }
          _context10.next = 7;
          return (0, _effects.put)((0, _user.userSuccess)(_user2.actionTypes.BRAND_USER_LIST, response === null || response === void 0 ? void 0 : (_response$data24 = response.data) === null || _response$data24 === void 0 ? void 0 : _response$data24.data));
        case 7:
          _context10.next = 11;
          break;
        case 9:
          _context10.next = 11;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.BRAND_USER_LIST, response === null || response === void 0 ? void 0 : (_response$data25 = response.data) === null || _response$data25 === void 0 ? void 0 : _response$data25.message));
        case 11:
          _context10.next = 17;
          break;
        case 13:
          _context10.prev = 13;
          _context10.t0 = _context10["catch"](0);
          _context10.next = 17;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.BRAND_USER_LIST, _context10.t0));
        case 17:
        case "end":
          return _context10.stop();
      }
    }, _callee9, null, [[0, 13]]);
  })();
}

/* list
 * @param payload
 * @returns api response
 * @description this function used to get user's list.
 */
function contentUserList(_ref10) {
  var payload = _ref10.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
    var _response$data26, response, _response$data27, _response$data28;
    return _regeneratorRuntime().wrap(function _callee10$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          _context11.prev = 0;
          _context11.next = 3;
          return (0, _effects.call)(_services.contentUserListApi, payload);
        case 3:
          response = _context11.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data26 = response.data) === null || _response$data26 === void 0 ? void 0 : _response$data26.code) === 200)) {
            _context11.next = 9;
            break;
          }
          _context11.next = 7;
          return (0, _effects.put)((0, _user.userSuccess)(_user2.actionTypes.CONTENT_USER_LIST, response === null || response === void 0 ? void 0 : (_response$data27 = response.data) === null || _response$data27 === void 0 ? void 0 : _response$data27.data));
        case 7:
          _context11.next = 11;
          break;
        case 9:
          _context11.next = 11;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.CONTENT_USER_LIST, response === null || response === void 0 ? void 0 : (_response$data28 = response.data) === null || _response$data28 === void 0 ? void 0 : _response$data28.message));
        case 11:
          _context11.next = 17;
          break;
        case 13:
          _context11.prev = 13;
          _context11.t0 = _context11["catch"](0);
          _context11.next = 17;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.CONTENT_USER_LIST, _context11.t0));
        case 17:
        case "end":
          return _context11.stop();
      }
    }, _callee10, null, [[0, 13]]);
  })();
}

/* list
 * @param payload
 * @returns api response
 * @description this function used to get user's list.
 */
function applicationUserList(_ref11) {
  var payload = _ref11.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
    var _response$data29, response, _response$data30, _response$data31;
    return _regeneratorRuntime().wrap(function _callee11$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          _context12.prev = 0;
          _context12.next = 3;
          return (0, _effects.call)(_services.applicationUserListApi, payload);
        case 3:
          response = _context12.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data29 = response.data) === null || _response$data29 === void 0 ? void 0 : _response$data29.code) === 200)) {
            _context12.next = 9;
            break;
          }
          _context12.next = 7;
          return (0, _effects.put)((0, _user.userSuccess)(_user2.actionTypes.APPLICATION_USER_LIST, response === null || response === void 0 ? void 0 : (_response$data30 = response.data) === null || _response$data30 === void 0 ? void 0 : _response$data30.data));
        case 7:
          _context12.next = 11;
          break;
        case 9:
          _context12.next = 11;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.APPLICATION_USER_LIST, response === null || response === void 0 ? void 0 : (_response$data31 = response.data) === null || _response$data31 === void 0 ? void 0 : _response$data31.message));
        case 11:
          _context12.next = 17;
          break;
        case 13:
          _context12.prev = 13;
          _context12.t0 = _context12["catch"](0);
          _context12.next = 17;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.APPLICATION_USER_LIST, _context12.t0));
        case 17:
        case "end":
          return _context12.stop();
      }
    }, _callee11, null, [[0, 13]]);
  })();
}

/* list
 * @param payload
 * @returns api response
 * @description this function used to get user's list.
 */
function dataUserList(_ref12) {
  var payload = _ref12.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
    var _response$data32, response, _response$data33, _response$data34;
    return _regeneratorRuntime().wrap(function _callee12$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          _context13.prev = 0;
          _context13.next = 3;
          return (0, _effects.call)(_services.dataUserListApi, payload);
        case 3:
          response = _context13.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data32 = response.data) === null || _response$data32 === void 0 ? void 0 : _response$data32.code) === 200)) {
            _context13.next = 9;
            break;
          }
          _context13.next = 7;
          return (0, _effects.put)((0, _user.userSuccess)(_user2.actionTypes.DATA_USER_LIST, response === null || response === void 0 ? void 0 : (_response$data33 = response.data) === null || _response$data33 === void 0 ? void 0 : _response$data33.data));
        case 7:
          _context13.next = 11;
          break;
        case 9:
          _context13.next = 11;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.DATA_USER_LIST, response === null || response === void 0 ? void 0 : (_response$data34 = response.data) === null || _response$data34 === void 0 ? void 0 : _response$data34.message));
        case 11:
          _context13.next = 17;
          break;
        case 13:
          _context13.prev = 13;
          _context13.t0 = _context13["catch"](0);
          _context13.next = 17;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.DATA_USER_LIST, _context13.t0));
        case 17:
        case "end":
          return _context13.stop();
      }
    }, _callee12, null, [[0, 13]]);
  })();
}

/* list
 * @param payload
 * @returns api response
 * @description this function used to get user's list.
 */
function reportUserList(_ref13) {
  var payload = _ref13.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
    var _response$data35, response, _response$data36, _response$data37;
    return _regeneratorRuntime().wrap(function _callee13$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          _context14.prev = 0;
          _context14.next = 3;
          return (0, _effects.call)(_services.reportUserListApi, payload);
        case 3:
          response = _context14.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data35 = response.data) === null || _response$data35 === void 0 ? void 0 : _response$data35.code) === 200)) {
            _context14.next = 9;
            break;
          }
          _context14.next = 7;
          return (0, _effects.put)((0, _user.userSuccess)(_user2.actionTypes.REPORT_USER_LIST, response === null || response === void 0 ? void 0 : (_response$data36 = response.data) === null || _response$data36 === void 0 ? void 0 : _response$data36.data));
        case 7:
          _context14.next = 11;
          break;
        case 9:
          _context14.next = 11;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.REPORT_USER_LIST, response === null || response === void 0 ? void 0 : (_response$data37 = response.data) === null || _response$data37 === void 0 ? void 0 : _response$data37.message));
        case 11:
          _context14.next = 17;
          break;
        case 13:
          _context14.prev = 13;
          _context14.t0 = _context14["catch"](0);
          _context14.next = 17;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.REPORT_USER_LIST, _context14.t0));
        case 17:
        case "end":
          return _context14.stop();
      }
    }, _callee13, null, [[0, 13]]);
  })();
}

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update user.
 */
function userUpdate(_ref14) {
  var payload = _ref14.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
    var _response$data38, response, _response$data39, _response$data40, _response$data41;
    return _regeneratorRuntime().wrap(function _callee14$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          _context15.prev = 0;
          _context15.next = 3;
          return (0, _effects.call)(_services.userUpdateApi, payload);
        case 3:
          response = _context15.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data38 = response.data) === null || _response$data38 === void 0 ? void 0 : _response$data38.code) === 202)) {
            _context15.next = 9;
            break;
          }
          _context15.next = 7;
          return (0, _effects.put)((0, _user.userSuccess)(_user2.actionTypes.UPDATE, response === null || response === void 0 ? void 0 : (_response$data39 = response.data) === null || _response$data39 === void 0 ? void 0 : _response$data39.data));
        case 7:
          _context15.next = 11;
          break;
        case 9:
          _context15.next = 11;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.UPDATE, (response === null || response === void 0 ? void 0 : (_response$data40 = response.data) === null || _response$data40 === void 0 ? void 0 : _response$data40.data) || (response === null || response === void 0 ? void 0 : (_response$data41 = response.data) === null || _response$data41 === void 0 ? void 0 : _response$data41.message)));
        case 11:
          _context15.next = 17;
          break;
        case 13:
          _context15.prev = 13;
          _context15.t0 = _context15["catch"](0);
          _context15.next = 17;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.UPDATE, _context15.t0));
        case 17:
        case "end":
          return _context15.stop();
      }
    }, _callee14, null, [[0, 13]]);
  })();
}

/**
 * soft delete
 * @param payload
 * @returns api response
 * @description this function used to soft delete user.
 */
function userSoftDelete(_ref15) {
  var payload = _ref15.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
    var _response$data42, response, _response$data43, _response$data44;
    return _regeneratorRuntime().wrap(function _callee15$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          _context16.prev = 0;
          _context16.next = 3;
          return (0, _effects.call)(_services.userSoftDeleteApi, payload);
        case 3:
          response = _context16.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data42 = response.data) === null || _response$data42 === void 0 ? void 0 : _response$data42.code) === 202)) {
            _context16.next = 9;
            break;
          }
          _context16.next = 7;
          return (0, _effects.put)((0, _user.userSuccess)(_user2.actionTypes.SOFT_DELETE, response === null || response === void 0 ? void 0 : (_response$data43 = response.data) === null || _response$data43 === void 0 ? void 0 : _response$data43.data));
        case 7:
          _context16.next = 11;
          break;
        case 9:
          _context16.next = 11;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.SOFT_DELETE, response === null || response === void 0 ? void 0 : (_response$data44 = response.data) === null || _response$data44 === void 0 ? void 0 : _response$data44.message));
        case 11:
          _context16.next = 17;
          break;
        case 13:
          _context16.prev = 13;
          _context16.t0 = _context16["catch"](0);
          _context16.next = 17;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.SOFT_DELETE, _context16.t0));
        case 17:
        case "end":
          return _context16.stop();
      }
    }, _callee15, null, [[0, 13]]);
  })();
}

/**
 * hard delete
 * @param payload
 * @returns api response
 * @description this function used to hard delete user.
 */
function userHardDelete(_ref16) {
  var payload = _ref16.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
    var _response$data45, response, _response$data46, _response$data47;
    return _regeneratorRuntime().wrap(function _callee16$(_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          _context17.prev = 0;
          _context17.next = 3;
          return (0, _effects.call)(_services.userHardDeleteApi, payload);
        case 3:
          response = _context17.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data45 = response.data) === null || _response$data45 === void 0 ? void 0 : _response$data45.code) === 202)) {
            _context17.next = 9;
            break;
          }
          _context17.next = 7;
          return (0, _effects.put)((0, _user.userSuccess)(_user2.actionTypes.HARD_DELETE, response === null || response === void 0 ? void 0 : (_response$data46 = response.data) === null || _response$data46 === void 0 ? void 0 : _response$data46.data));
        case 7:
          _context17.next = 11;
          break;
        case 9:
          _context17.next = 11;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.HARD_DELETE, response === null || response === void 0 ? void 0 : (_response$data47 = response.data) === null || _response$data47 === void 0 ? void 0 : _response$data47.message));
        case 11:
          _context17.next = 17;
          break;
        case 13:
          _context17.prev = 13;
          _context17.t0 = _context17["catch"](0);
          _context17.next = 17;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.HARD_DELETE, _context17.t0));
        case 17:
        case "end":
          return _context17.stop();
      }
    }, _callee16, null, [[0, 13]]);
  })();
}

/**
 * soft restore
 * @param payload
 * @returns api response
 * @description this function used to soft restore user.
 */
function userSoftRestore(_ref17) {
  var payload = _ref17.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
    var _response$data48, response;
    return _regeneratorRuntime().wrap(function _callee17$(_context18) {
      while (1) switch (_context18.prev = _context18.next) {
        case 0:
          _context18.prev = 0;
          _context18.next = 3;
          return (0, _effects.call)(_services.userSoftRestoreApi, payload);
        case 3:
          response = _context18.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data48 = response.data) === null || _response$data48 === void 0 ? void 0 : _response$data48.code) === 202)) {
            _context18.next = 9;
            break;
          }
          _context18.next = 7;
          return (0, _effects.put)((0, _user.userSuccess)(_user2.actionTypes.SOFT_RESTORE, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context18.next = 11;
          break;
        case 9:
          _context18.next = 11;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.SOFT_RESTORE, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context18.next = 17;
          break;
        case 13:
          _context18.prev = 13;
          _context18.t0 = _context18["catch"](0);
          _context18.next = 17;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.SOFT_RESTORE, _context18.t0));
        case 17:
        case "end":
          return _context18.stop();
      }
    }, _callee17, null, [[0, 13]]);
  })();
}

/**
 * soft deleted list
 * @param payload
 * @returns api response
 * @description this function used to soft deleted list.
 */
function userSoftDeletedList(_ref18) {
  var payload = _ref18.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
    var _payload7, _payload7$fkDeletedBy, _payload8, _payload8$fkDeletedBy, _payload9, _payload10, _payload11, _payload12, _payload13, _response$data49, filter, response, _response$data50, _response$data51;
    return _regeneratorRuntime().wrap(function _callee18$(_context19) {
      while (1) switch (_context19.prev = _context19.next) {
        case 0:
          _context19.prev = 0;
          filter = {}; // Owner
          if ((_payload7 = payload) !== null && _payload7 !== void 0 && (_payload7$fkDeletedBy = _payload7.fkDeletedByList) !== null && _payload7$fkDeletedBy !== void 0 && _payload7$fkDeletedBy.value) filter["fkDeletedByList"] = (_payload8 = payload) === null || _payload8 === void 0 ? void 0 : (_payload8$fkDeletedBy = _payload8.fkDeletedByList) === null || _payload8$fkDeletedBy === void 0 ? void 0 : _payload8$fkDeletedBy.value;else if (Array.isArray((_payload9 = payload) === null || _payload9 === void 0 ? void 0 : _payload9.fkDeletedByList)) filter["fkDeletedByList"] = (_payload10 = payload) === null || _payload10 === void 0 ? void 0 : _payload10.fkDeletedByList;
          if (((_payload11 = payload) === null || _payload11 === void 0 ? void 0 : _payload11.dateRange) === "date" && (_payload12 = payload) !== null && _payload12 !== void 0 && _payload12.from && (_payload13 = payload) !== null && _payload13 !== void 0 && _payload13.to) {
            filter["startDate"] = payload.from;
            filter["endDate"] = payload.to;
          }
          delete payload.fkDeletedByList;
          delete payload.from;
          delete payload.to;
          delete payload.dateRange;
          delete payload.startDate;
          delete payload.endDate;
          payload = _objectSpread(_objectSpread({}, filter), payload);
          _context19.next = 13;
          return (0, _effects.call)(_services.userSoftDeletedListApi, payload);
        case 13:
          response = _context19.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data49 = response.data) === null || _response$data49 === void 0 ? void 0 : _response$data49.code) === 200)) {
            _context19.next = 19;
            break;
          }
          _context19.next = 17;
          return (0, _effects.put)((0, _user.userSuccess)(_user2.actionTypes.SOFT_DELETE_LIST, response === null || response === void 0 ? void 0 : (_response$data50 = response.data) === null || _response$data50 === void 0 ? void 0 : _response$data50.data));
        case 17:
          _context19.next = 21;
          break;
        case 19:
          _context19.next = 21;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.SOFT_DELETE_LIST, response === null || response === void 0 ? void 0 : (_response$data51 = response.data) === null || _response$data51 === void 0 ? void 0 : _response$data51.message));
        case 21:
          _context19.next = 27;
          break;
        case 23:
          _context19.prev = 23;
          _context19.t0 = _context19["catch"](0);
          _context19.next = 27;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.SOFT_DELETE_LIST, _context19.t0));
        case 27:
        case "end":
          return _context19.stop();
      }
    }, _callee18, null, [[0, 23]]);
  })();
}

/**
 * unique email
 * @param payload
 * @returns api response
 * @description this function used to unique email.
 */
function userUniqueEmail(_ref19) {
  var payload = _ref19.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
    var _response$data52, response;
    return _regeneratorRuntime().wrap(function _callee19$(_context20) {
      while (1) switch (_context20.prev = _context20.next) {
        case 0:
          _context20.prev = 0;
          _context20.next = 3;
          return (0, _effects.call)(_services.userUniqueEmailApi, payload);
        case 3:
          response = _context20.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data52 = response.data) === null || _response$data52 === void 0 ? void 0 : _response$data52.code) === 202)) {
            _context20.next = 9;
            break;
          }
          _context20.next = 7;
          return (0, _effects.put)((0, _user.userSuccess)(_user2.actionTypes.UNIQUE_EMAIL, response.data.data));
        case 7:
          _context20.next = 11;
          break;
        case 9:
          _context20.next = 11;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.UNIQUE_EMAIL, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context20.next = 17;
          break;
        case 13:
          _context20.prev = 13;
          _context20.t0 = _context20["catch"](0);
          _context20.next = 17;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.UNIQUE_EMAIL, _context20.t0));
        case 17:
        case "end":
          return _context20.stop();
      }
    }, _callee19, null, [[0, 13]]);
  })();
}

/**
 * user bulk delete
 * @param payload
 * @returns api response
 * @description this function used to user bulk delete.
 */
function userBulkHardDelete(_ref20) {
  var payload = _ref20.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
    var _payload14, _payload14$filterCrit, _payload15, _payload15$filterCrit, _payload16, _payload16$filterCrit, _payload16$filterCrit2, _payload18, _payload18$filterCrit, _payload18$filterCrit2, _response$data53, filter, _payload17, _payload17$filterCrit, _payload19, _payload19$filterCrit, _payload19$filterCrit2, _payload19$filterCrit3, _payload21, _payload21$filterCrit, _payload21$filterCrit2, _payload21$filterCrit3, _payload20, _payload20$filterCrit, _payload20$filterCrit2, _payload22, _payload22$filterCrit, _payload22$filterCrit2, isActive, response, _response$data54, _response$data55;
    return _regeneratorRuntime().wrap(function _callee20$(_context21) {
      while (1) switch (_context21.prev = _context21.next) {
        case 0:
          _context21.prev = 0;
          filter = {}; // Search Text
          if ((_payload14 = payload) !== null && _payload14 !== void 0 && (_payload14$filterCrit = _payload14.filterCriteria) !== null && _payload14$filterCrit !== void 0 && _payload14$filterCrit.searchText) filter["searchText"] = (_payload15 = payload) === null || _payload15 === void 0 ? void 0 : (_payload15$filterCrit = _payload15.filterCriteria) === null || _payload15$filterCrit === void 0 ? void 0 : _payload15$filterCrit.searchText;
          if (((_payload16 = payload) === null || _payload16 === void 0 ? void 0 : (_payload16$filterCrit = _payload16.filterCriteria) === null || _payload16$filterCrit === void 0 ? void 0 : (_payload16$filterCrit2 = _payload16$filterCrit.roleIdList) === null || _payload16$filterCrit2 === void 0 ? void 0 : _payload16$filterCrit2.length) > 0) {
            filter["roleIdList"] = (_payload17 = payload) === null || _payload17 === void 0 ? void 0 : (_payload17$filterCrit = _payload17.filterCriteria) === null || _payload17$filterCrit === void 0 ? void 0 : _payload17$filterCrit.roleIdList;
          }
          if (((_payload18 = payload) === null || _payload18 === void 0 ? void 0 : (_payload18$filterCrit = _payload18.filterCriteria) === null || _payload18$filterCrit === void 0 ? void 0 : (_payload18$filterCrit2 = _payload18$filterCrit.isActive) === null || _payload18$filterCrit2 === void 0 ? void 0 : _payload18$filterCrit2.length) > 0) {
            if (((_payload19 = payload) === null || _payload19 === void 0 ? void 0 : (_payload19$filterCrit = _payload19.filterCriteria) === null || _payload19$filterCrit === void 0 ? void 0 : (_payload19$filterCrit2 = _payload19$filterCrit.isActive) === null || _payload19$filterCrit2 === void 0 ? void 0 : (_payload19$filterCrit3 = _payload19$filterCrit2.filter(function (el) {
              return el === true || el === false;
            })) === null || _payload19$filterCrit3 === void 0 ? void 0 : _payload19$filterCrit3.length) === 1) {
              filter["isActive"] = (_payload20 = payload) === null || _payload20 === void 0 ? void 0 : (_payload20$filterCrit = _payload20.filterCriteria) === null || _payload20$filterCrit === void 0 ? void 0 : (_payload20$filterCrit2 = _payload20$filterCrit.isActive) === null || _payload20$filterCrit2 === void 0 ? void 0 : _payload20$filterCrit2.find(function (el) {
                return el === true || el === false;
              });
            }
            if (((_payload21 = payload) === null || _payload21 === void 0 ? void 0 : (_payload21$filterCrit = _payload21.filterCriteria) === null || _payload21$filterCrit === void 0 ? void 0 : (_payload21$filterCrit2 = _payload21$filterCrit.isActive) === null || _payload21$filterCrit2 === void 0 ? void 0 : (_payload21$filterCrit3 = _payload21$filterCrit2.filter(function (el) {
              return el === 0 || el === 1;
            })) === null || _payload21$filterCrit3 === void 0 ? void 0 : _payload21$filterCrit3.length) === 1) {
              isActive = (_payload22 = payload) === null || _payload22 === void 0 ? void 0 : (_payload22$filterCrit = _payload22.filterCriteria) === null || _payload22$filterCrit === void 0 ? void 0 : (_payload22$filterCrit2 = _payload22$filterCrit.isActive) === null || _payload22$filterCrit2 === void 0 ? void 0 : _payload22$filterCrit2.filter(function (el) {
                return el === 0 || el === 1;
              })[0];
              filter["loginStatus"] = isActive ? true : false;
            }
          }
          delete payload.filterCriteria;
          payload = _objectSpread({
            filterCriteria: filter
          }, payload);
          _context21.next = 9;
          return (0, _effects.call)(_services.userBulkHardDeleteApi, payload);
        case 9:
          response = _context21.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data53 = response.data) === null || _response$data53 === void 0 ? void 0 : _response$data53.code) === 207)) {
            _context21.next = 15;
            break;
          }
          _context21.next = 13;
          return (0, _effects.put)((0, _user.userSuccess)(_user2.actionTypes.BULK_HARD_DELETE, response === null || response === void 0 ? void 0 : (_response$data54 = response.data) === null || _response$data54 === void 0 ? void 0 : _response$data54.data));
        case 13:
          _context21.next = 17;
          break;
        case 15:
          _context21.next = 17;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.BULK_HARD_DELETE, response === null || response === void 0 ? void 0 : (_response$data55 = response.data) === null || _response$data55 === void 0 ? void 0 : _response$data55.message));
        case 17:
          _context21.next = 23;
          break;
        case 19:
          _context21.prev = 19;
          _context21.t0 = _context21["catch"](0);
          _context21.next = 23;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.BULK_HARD_DELETE, _context21.t0));
        case 23:
        case "end":
          return _context21.stop();
      }
    }, _callee20, null, [[0, 19]]);
  })();
}

/**
 * user bulk activate
 * @param payload
 * @returns api response
 * @description this function used to user bulk activate.
 */
function userBulkActivate(_ref21) {
  var payload = _ref21.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
    var _payload23, _payload23$filterCrit, _payload24, _payload24$filterCrit, _payload25, _payload25$filterCrit, _payload25$filterCrit2, _payload27, _payload27$filterCrit, _payload27$filterCrit2, _response$data56, filter, _payload26, _payload26$filterCrit, _payload28, _payload28$filterCrit, _payload28$filterCrit2, _payload28$filterCrit3, _payload30, _payload30$filterCrit, _payload30$filterCrit2, _payload30$filterCrit3, _payload29, _payload29$filterCrit, _payload29$filterCrit2, _payload31, _payload31$filterCrit, _payload31$filterCrit2, isActive, response, _response$data57, _response$data58;
    return _regeneratorRuntime().wrap(function _callee21$(_context22) {
      while (1) switch (_context22.prev = _context22.next) {
        case 0:
          _context22.prev = 0;
          filter = {}; // Search Text
          if ((_payload23 = payload) !== null && _payload23 !== void 0 && (_payload23$filterCrit = _payload23.filterCriteria) !== null && _payload23$filterCrit !== void 0 && _payload23$filterCrit.searchText) filter["searchText"] = (_payload24 = payload) === null || _payload24 === void 0 ? void 0 : (_payload24$filterCrit = _payload24.filterCriteria) === null || _payload24$filterCrit === void 0 ? void 0 : _payload24$filterCrit.searchText;
          if (((_payload25 = payload) === null || _payload25 === void 0 ? void 0 : (_payload25$filterCrit = _payload25.filterCriteria) === null || _payload25$filterCrit === void 0 ? void 0 : (_payload25$filterCrit2 = _payload25$filterCrit.roleIdList) === null || _payload25$filterCrit2 === void 0 ? void 0 : _payload25$filterCrit2.length) > 0) {
            filter["roleIdList"] = (_payload26 = payload) === null || _payload26 === void 0 ? void 0 : (_payload26$filterCrit = _payload26.filterCriteria) === null || _payload26$filterCrit === void 0 ? void 0 : _payload26$filterCrit.roleIdList;
          }
          if (((_payload27 = payload) === null || _payload27 === void 0 ? void 0 : (_payload27$filterCrit = _payload27.filterCriteria) === null || _payload27$filterCrit === void 0 ? void 0 : (_payload27$filterCrit2 = _payload27$filterCrit.isActive) === null || _payload27$filterCrit2 === void 0 ? void 0 : _payload27$filterCrit2.length) > 0) {
            if (((_payload28 = payload) === null || _payload28 === void 0 ? void 0 : (_payload28$filterCrit = _payload28.filterCriteria) === null || _payload28$filterCrit === void 0 ? void 0 : (_payload28$filterCrit2 = _payload28$filterCrit.isActive) === null || _payload28$filterCrit2 === void 0 ? void 0 : (_payload28$filterCrit3 = _payload28$filterCrit2.filter(function (el) {
              return el === true || el === false;
            })) === null || _payload28$filterCrit3 === void 0 ? void 0 : _payload28$filterCrit3.length) === 1) {
              filter["isActive"] = (_payload29 = payload) === null || _payload29 === void 0 ? void 0 : (_payload29$filterCrit = _payload29.filterCriteria) === null || _payload29$filterCrit === void 0 ? void 0 : (_payload29$filterCrit2 = _payload29$filterCrit.isActive) === null || _payload29$filterCrit2 === void 0 ? void 0 : _payload29$filterCrit2.find(function (el) {
                return el === true || el === false;
              });
            }
            if (((_payload30 = payload) === null || _payload30 === void 0 ? void 0 : (_payload30$filterCrit = _payload30.filterCriteria) === null || _payload30$filterCrit === void 0 ? void 0 : (_payload30$filterCrit2 = _payload30$filterCrit.isActive) === null || _payload30$filterCrit2 === void 0 ? void 0 : (_payload30$filterCrit3 = _payload30$filterCrit2.filter(function (el) {
              return el === 0 || el === 1;
            })) === null || _payload30$filterCrit3 === void 0 ? void 0 : _payload30$filterCrit3.length) === 1) {
              isActive = (_payload31 = payload) === null || _payload31 === void 0 ? void 0 : (_payload31$filterCrit = _payload31.filterCriteria) === null || _payload31$filterCrit === void 0 ? void 0 : (_payload31$filterCrit2 = _payload31$filterCrit.isActive) === null || _payload31$filterCrit2 === void 0 ? void 0 : _payload31$filterCrit2.filter(function (el) {
                return el === 0 || el === 1;
              })[0];
              filter["loginStatus"] = isActive ? true : false;
            }
          }
          delete payload.filterCriteria;
          payload = _objectSpread({
            filterCriteria: filter
          }, payload);
          _context22.next = 9;
          return (0, _effects.call)(_services.userBulkActivateApi, payload);
        case 9:
          response = _context22.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data56 = response.data) === null || _response$data56 === void 0 ? void 0 : _response$data56.code) === 207)) {
            _context22.next = 15;
            break;
          }
          _context22.next = 13;
          return (0, _effects.put)((0, _user.userSuccess)(_user2.actionTypes.BULK_ACTIVATE, response === null || response === void 0 ? void 0 : (_response$data57 = response.data) === null || _response$data57 === void 0 ? void 0 : _response$data57.data));
        case 13:
          _context22.next = 17;
          break;
        case 15:
          _context22.next = 17;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.BULK_ACTIVATE, response === null || response === void 0 ? void 0 : (_response$data58 = response.data) === null || _response$data58 === void 0 ? void 0 : _response$data58.message));
        case 17:
          _context22.next = 23;
          break;
        case 19:
          _context22.prev = 19;
          _context22.t0 = _context22["catch"](0);
          _context22.next = 23;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.BULK_ACTIVATE, _context22.t0));
        case 23:
        case "end":
          return _context22.stop();
      }
    }, _callee21, null, [[0, 19]]);
  })();
}

/**
 * user bulk deactivate
 * @param payload
 * @returns api response
 * @description this function used to user bulk deactivate.
 */
function userBulkDeactivate(_ref22) {
  var payload = _ref22.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
    var _payload32, _payload32$filterCrit, _payload33, _payload33$filterCrit, _payload34, _payload34$filterCrit, _payload34$filterCrit2, _payload36, _payload36$filterCrit, _payload36$filterCrit2, _response$data59, filter, _payload35, _payload35$filterCrit, _payload37, _payload37$filterCrit, _payload37$filterCrit2, _payload37$filterCrit3, _payload39, _payload39$filterCrit, _payload39$filterCrit2, _payload39$filterCrit3, _payload38, _payload38$filterCrit, _payload38$filterCrit2, _payload40, _payload40$filterCrit, _payload40$filterCrit2, isActive, response, _response$data60, _response$data61;
    return _regeneratorRuntime().wrap(function _callee22$(_context23) {
      while (1) switch (_context23.prev = _context23.next) {
        case 0:
          _context23.prev = 0;
          filter = {}; // Search Text
          if ((_payload32 = payload) !== null && _payload32 !== void 0 && (_payload32$filterCrit = _payload32.filterCriteria) !== null && _payload32$filterCrit !== void 0 && _payload32$filterCrit.searchText) filter["searchText"] = (_payload33 = payload) === null || _payload33 === void 0 ? void 0 : (_payload33$filterCrit = _payload33.filterCriteria) === null || _payload33$filterCrit === void 0 ? void 0 : _payload33$filterCrit.searchText;
          if (((_payload34 = payload) === null || _payload34 === void 0 ? void 0 : (_payload34$filterCrit = _payload34.filterCriteria) === null || _payload34$filterCrit === void 0 ? void 0 : (_payload34$filterCrit2 = _payload34$filterCrit.roleIdList) === null || _payload34$filterCrit2 === void 0 ? void 0 : _payload34$filterCrit2.length) > 0) {
            filter["roleIdList"] = (_payload35 = payload) === null || _payload35 === void 0 ? void 0 : (_payload35$filterCrit = _payload35.filterCriteria) === null || _payload35$filterCrit === void 0 ? void 0 : _payload35$filterCrit.roleIdList;
          }
          if (((_payload36 = payload) === null || _payload36 === void 0 ? void 0 : (_payload36$filterCrit = _payload36.filterCriteria) === null || _payload36$filterCrit === void 0 ? void 0 : (_payload36$filterCrit2 = _payload36$filterCrit.isActive) === null || _payload36$filterCrit2 === void 0 ? void 0 : _payload36$filterCrit2.length) > 0) {
            if (((_payload37 = payload) === null || _payload37 === void 0 ? void 0 : (_payload37$filterCrit = _payload37.filterCriteria) === null || _payload37$filterCrit === void 0 ? void 0 : (_payload37$filterCrit2 = _payload37$filterCrit.isActive) === null || _payload37$filterCrit2 === void 0 ? void 0 : (_payload37$filterCrit3 = _payload37$filterCrit2.filter(function (el) {
              return el === true || el === false;
            })) === null || _payload37$filterCrit3 === void 0 ? void 0 : _payload37$filterCrit3.length) === 1) {
              filter["isActive"] = (_payload38 = payload) === null || _payload38 === void 0 ? void 0 : (_payload38$filterCrit = _payload38.filterCriteria) === null || _payload38$filterCrit === void 0 ? void 0 : (_payload38$filterCrit2 = _payload38$filterCrit.isActive) === null || _payload38$filterCrit2 === void 0 ? void 0 : _payload38$filterCrit2.find(function (el) {
                return el === true || el === false;
              });
            }
            if (((_payload39 = payload) === null || _payload39 === void 0 ? void 0 : (_payload39$filterCrit = _payload39.filterCriteria) === null || _payload39$filterCrit === void 0 ? void 0 : (_payload39$filterCrit2 = _payload39$filterCrit.isActive) === null || _payload39$filterCrit2 === void 0 ? void 0 : (_payload39$filterCrit3 = _payload39$filterCrit2.filter(function (el) {
              return el === 0 || el === 1;
            })) === null || _payload39$filterCrit3 === void 0 ? void 0 : _payload39$filterCrit3.length) === 1) {
              isActive = (_payload40 = payload) === null || _payload40 === void 0 ? void 0 : (_payload40$filterCrit = _payload40.filterCriteria) === null || _payload40$filterCrit === void 0 ? void 0 : (_payload40$filterCrit2 = _payload40$filterCrit.isActive) === null || _payload40$filterCrit2 === void 0 ? void 0 : _payload40$filterCrit2.filter(function (el) {
                return el === 0 || el === 1;
              })[0];
              filter["loginStatus"] = isActive ? true : false;
            }
          }
          delete payload.filterCriteria;
          payload = _objectSpread({
            filterCriteria: filter
          }, payload);
          _context23.next = 9;
          return (0, _effects.call)(_services.userBulkDeactivateApi, payload);
        case 9:
          response = _context23.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data59 = response.data) === null || _response$data59 === void 0 ? void 0 : _response$data59.code) === 207)) {
            _context23.next = 15;
            break;
          }
          _context23.next = 13;
          return (0, _effects.put)((0, _user.userSuccess)(_user2.actionTypes.BULK_DEACTIVATE, response === null || response === void 0 ? void 0 : (_response$data60 = response.data) === null || _response$data60 === void 0 ? void 0 : _response$data60.data));
        case 13:
          _context23.next = 17;
          break;
        case 15:
          _context23.next = 17;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.BULK_DEACTIVATE, response === null || response === void 0 ? void 0 : (_response$data61 = response.data) === null || _response$data61 === void 0 ? void 0 : _response$data61.message));
        case 17:
          _context23.next = 23;
          break;
        case 19:
          _context23.prev = 19;
          _context23.t0 = _context23["catch"](0);
          _context23.next = 23;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.BULK_DEACTIVATE, _context23.t0));
        case 23:
        case "end":
          return _context23.stop();
      }
    }, _callee22, null, [[0, 19]]);
  })();
}

/**
 * user activities
 * @param payload
 * @returns api response
 * @description this function used for user activities log.
 */
function userActivities(_ref23) {
  var payload = _ref23.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
    var _response$data62, response;
    return _regeneratorRuntime().wrap(function _callee23$(_context24) {
      while (1) switch (_context24.prev = _context24.next) {
        case 0:
          _context24.prev = 0;
          _context24.next = 3;
          return (0, _effects.call)(_services.userActivitiesApi, payload);
        case 3:
          response = _context24.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data62 = response.data) === null || _response$data62 === void 0 ? void 0 : _response$data62.code) === 201)) {
            _context24.next = 9;
            break;
          }
          _context24.next = 7;
          return (0, _effects.put)((0, _user.userSuccess)(_user2.actionTypes.ACTIVITIES, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context24.next = 11;
          break;
        case 9:
          _context24.next = 11;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.ACTIVITIES, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context24.next = 17;
          break;
        case 13:
          _context24.prev = 13;
          _context24.t0 = _context24["catch"](0);
          _context24.next = 17;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.ACTIVITIES, _context24.t0));
        case 17:
        case "end":
          return _context24.stop();
      }
    }, _callee23, null, [[0, 13]]);
  })();
}

/** Authorize device
 * @param payload
 * @returns api response
 * @description this function used to check validated token.
 */
function userAuthorizeDevice(_ref24) {
  var payload = _ref24.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
    var _response$data63, response;
    return _regeneratorRuntime().wrap(function _callee24$(_context25) {
      while (1) switch (_context25.prev = _context25.next) {
        case 0:
          _context25.prev = 0;
          _context25.next = 3;
          return (0, _effects.call)(_services.userAuthorizeDeviceApi, payload);
        case 3:
          response = _context25.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data63 = response.data) === null || _response$data63 === void 0 ? void 0 : _response$data63.code) === 202)) {
            _context25.next = 9;
            break;
          }
          _context25.next = 7;
          return (0, _effects.put)((0, _user.userSuccess)(_user2.actionTypes.AUTHORIZE_DEVICE, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context25.next = 11;
          break;
        case 9:
          _context25.next = 11;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.AUTHORIZE_DEVICE, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context25.next = 17;
          break;
        case 13:
          _context25.prev = 13;
          _context25.t0 = _context25["catch"](0);
          _context25.next = 17;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.AUTHORIZE_DEVICE, _context25.t0));
        case 17:
        case "end":
          return _context25.stop();
      }
    }, _callee24, null, [[0, 13]]);
  })();
}

/**
 * Activate user
 * @param payload
 * @returns api response
 * @description this function used to activate user.
 */
function userActivateUser(_ref25) {
  var payload = _ref25.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
    var _response$data64, response, _response$data65, _response$data66, _response$data67;
    return _regeneratorRuntime().wrap(function _callee25$(_context26) {
      while (1) switch (_context26.prev = _context26.next) {
        case 0:
          _context26.prev = 0;
          _context26.next = 3;
          return (0, _effects.call)(_services.userActivateUserApi, payload);
        case 3:
          response = _context26.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data64 = response.data) === null || _response$data64 === void 0 ? void 0 : _response$data64.code) === 202)) {
            _context26.next = 9;
            break;
          }
          _context26.next = 7;
          return (0, _effects.put)((0, _user.userSuccess)(_user2.actionTypes.ACTIVATE_USER, response === null || response === void 0 ? void 0 : (_response$data65 = response.data) === null || _response$data65 === void 0 ? void 0 : _response$data65.data));
        case 7:
          _context26.next = 11;
          break;
        case 9:
          _context26.next = 11;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.ACTIVATE_USER, (response === null || response === void 0 ? void 0 : (_response$data66 = response.data) === null || _response$data66 === void 0 ? void 0 : _response$data66.data) || (response === null || response === void 0 ? void 0 : (_response$data67 = response.data) === null || _response$data67 === void 0 ? void 0 : _response$data67.message)));
        case 11:
          _context26.next = 17;
          break;
        case 13:
          _context26.prev = 13;
          _context26.t0 = _context26["catch"](0);
          _context26.next = 17;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.ACTIVATE_USER, _context26.t0));
        case 17:
        case "end":
          return _context26.stop();
      }
    }, _callee25, null, [[0, 13]]);
  })();
}

/**
 * Deactivate user
 * @param payload
 * @returns api response
 * @description this function used to deactivate user.
 */
function userDeactivateUser(_ref26) {
  var payload = _ref26.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
    var _response$data68, response, _response$data69, _response$data70, _response$data71;
    return _regeneratorRuntime().wrap(function _callee26$(_context27) {
      while (1) switch (_context27.prev = _context27.next) {
        case 0:
          _context27.prev = 0;
          _context27.next = 3;
          return (0, _effects.call)(_services.userDeactivateUserApi, payload);
        case 3:
          response = _context27.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data68 = response.data) === null || _response$data68 === void 0 ? void 0 : _response$data68.code) === 202)) {
            _context27.next = 9;
            break;
          }
          _context27.next = 7;
          return (0, _effects.put)((0, _user.userSuccess)(_user2.actionTypes.DEACTIVATE_USER, response === null || response === void 0 ? void 0 : (_response$data69 = response.data) === null || _response$data69 === void 0 ? void 0 : _response$data69.data));
        case 7:
          _context27.next = 11;
          break;
        case 9:
          _context27.next = 11;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.DEACTIVATE_USER, (response === null || response === void 0 ? void 0 : (_response$data70 = response.data) === null || _response$data70 === void 0 ? void 0 : _response$data70.data) || (response === null || response === void 0 ? void 0 : (_response$data71 = response.data) === null || _response$data71 === void 0 ? void 0 : _response$data71.message)));
        case 11:
          _context27.next = 17;
          break;
        case 13:
          _context27.prev = 13;
          _context27.t0 = _context27["catch"](0);
          _context27.next = 17;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.DEACTIVATE_USER, _context27.t0));
        case 17:
        case "end":
          return _context27.stop();
      }
    }, _callee26, null, [[0, 13]]);
  })();
}

/**
 * Reset password common
 * @param payload
 * @returns api response
 * @description this function used to reset passworld its credencials.
 */
function userResetPasswordCommon(_ref27) {
  var payload = _ref27.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee27() {
    var _response$data72, response;
    return _regeneratorRuntime().wrap(function _callee27$(_context28) {
      while (1) switch (_context28.prev = _context28.next) {
        case 0:
          _context28.prev = 0;
          _context28.next = 3;
          return (0, _effects.call)(_services.userResetPasswordCommonApi, payload);
        case 3:
          response = _context28.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data72 = response.data) === null || _response$data72 === void 0 ? void 0 : _response$data72.code) === 202)) {
            _context28.next = 9;
            break;
          }
          _context28.next = 7;
          return (0, _effects.put)((0, _user.userSuccess)(_user2.actionTypes.RESET_PASSWORD_COMMON, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context28.next = 11;
          break;
        case 9:
          _context28.next = 11;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.RESET_PASSWORD_COMMON, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context28.next = 17;
          break;
        case 13:
          _context28.prev = 13;
          _context28.t0 = _context28["catch"](0);
          _context28.next = 17;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.RESET_PASSWORD_COMMON, _context28.t0));
        case 17:
        case "end":
          return _context28.stop();
      }
    }, _callee27, null, [[0, 13]]);
  })();
}

/* permission
 * @param payload
 * @returns api response
 * @description this function used to get user's permission.
 */
function userTenantPermission(_ref28) {
  var payload = _ref28.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee28() {
    var _response$data73, response, _response$data74, _response$data75;
    return _regeneratorRuntime().wrap(function _callee28$(_context29) {
      while (1) switch (_context29.prev = _context29.next) {
        case 0:
          _context29.prev = 0;
          _context29.next = 3;
          return (0, _effects.call)(_services.userTenantPermissionApi, payload);
        case 3:
          response = _context29.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data73 = response.data) === null || _response$data73 === void 0 ? void 0 : _response$data73.code) === 200)) {
            _context29.next = 9;
            break;
          }
          _context29.next = 7;
          return (0, _effects.put)((0, _user.userSuccess)(_user2.actionTypes.TENANT_PERMISSION, response === null || response === void 0 ? void 0 : (_response$data74 = response.data) === null || _response$data74 === void 0 ? void 0 : _response$data74.data));
        case 7:
          _context29.next = 11;
          break;
        case 9:
          _context29.next = 11;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.TENANT_PERMISSION, response === null || response === void 0 ? void 0 : (_response$data75 = response.data) === null || _response$data75 === void 0 ? void 0 : _response$data75.message));
        case 11:
          _context29.next = 17;
          break;
        case 13:
          _context29.prev = 13;
          _context29.t0 = _context29["catch"](0);
          _context29.next = 17;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.TENANT_PERMISSION, _context29.t0));
        case 17:
        case "end":
          return _context29.stop();
      }
    }, _callee28, null, [[0, 13]]);
  })();
}

/**
 * user bulk soft delete
 * @param payload
 * @returns api response
 * @description this function used to user bulk soft delete.
 */
function userBulkSoftDelete(_ref29) {
  var payload = _ref29.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee29() {
    var _payload41, _payload41$filterCrit, _payload42, _payload42$filterCrit, _payload43, _payload43$filterCrit, _payload43$filterCrit2, _payload45, _payload45$filterCrit, _payload45$filterCrit2, _response$data76, filter, _payload44, _payload44$filterCrit, _payload46, _payload46$filterCrit, _payload46$filterCrit2, _payload46$filterCrit3, _payload48, _payload48$filterCrit, _payload48$filterCrit2, _payload48$filterCrit3, _payload47, _payload47$filterCrit, _payload47$filterCrit2, _payload49, _payload49$filterCrit, _payload49$filterCrit2, isActive, response, _response$data77, _response$data78;
    return _regeneratorRuntime().wrap(function _callee29$(_context30) {
      while (1) switch (_context30.prev = _context30.next) {
        case 0:
          _context30.prev = 0;
          filter = {}; // Search Text
          if ((_payload41 = payload) !== null && _payload41 !== void 0 && (_payload41$filterCrit = _payload41.filterCriteria) !== null && _payload41$filterCrit !== void 0 && _payload41$filterCrit.searchText) filter["searchText"] = (_payload42 = payload) === null || _payload42 === void 0 ? void 0 : (_payload42$filterCrit = _payload42.filterCriteria) === null || _payload42$filterCrit === void 0 ? void 0 : _payload42$filterCrit.searchText;
          if (((_payload43 = payload) === null || _payload43 === void 0 ? void 0 : (_payload43$filterCrit = _payload43.filterCriteria) === null || _payload43$filterCrit === void 0 ? void 0 : (_payload43$filterCrit2 = _payload43$filterCrit.roleIdList) === null || _payload43$filterCrit2 === void 0 ? void 0 : _payload43$filterCrit2.length) > 0) {
            filter["roleIdList"] = (_payload44 = payload) === null || _payload44 === void 0 ? void 0 : (_payload44$filterCrit = _payload44.filterCriteria) === null || _payload44$filterCrit === void 0 ? void 0 : _payload44$filterCrit.roleIdList;
          }
          if (((_payload45 = payload) === null || _payload45 === void 0 ? void 0 : (_payload45$filterCrit = _payload45.filterCriteria) === null || _payload45$filterCrit === void 0 ? void 0 : (_payload45$filterCrit2 = _payload45$filterCrit.isActive) === null || _payload45$filterCrit2 === void 0 ? void 0 : _payload45$filterCrit2.length) > 0) {
            if (((_payload46 = payload) === null || _payload46 === void 0 ? void 0 : (_payload46$filterCrit = _payload46.filterCriteria) === null || _payload46$filterCrit === void 0 ? void 0 : (_payload46$filterCrit2 = _payload46$filterCrit.isActive) === null || _payload46$filterCrit2 === void 0 ? void 0 : (_payload46$filterCrit3 = _payload46$filterCrit2.filter(function (el) {
              return el === true || el === false;
            })) === null || _payload46$filterCrit3 === void 0 ? void 0 : _payload46$filterCrit3.length) === 1) {
              filter["isActive"] = (_payload47 = payload) === null || _payload47 === void 0 ? void 0 : (_payload47$filterCrit = _payload47.filterCriteria) === null || _payload47$filterCrit === void 0 ? void 0 : (_payload47$filterCrit2 = _payload47$filterCrit.isActive) === null || _payload47$filterCrit2 === void 0 ? void 0 : _payload47$filterCrit2.find(function (el) {
                return el === true || el === false;
              });
            }
            if (((_payload48 = payload) === null || _payload48 === void 0 ? void 0 : (_payload48$filterCrit = _payload48.filterCriteria) === null || _payload48$filterCrit === void 0 ? void 0 : (_payload48$filterCrit2 = _payload48$filterCrit.isActive) === null || _payload48$filterCrit2 === void 0 ? void 0 : (_payload48$filterCrit3 = _payload48$filterCrit2.filter(function (el) {
              return el === 0 || el === 1;
            })) === null || _payload48$filterCrit3 === void 0 ? void 0 : _payload48$filterCrit3.length) === 1) {
              isActive = (_payload49 = payload) === null || _payload49 === void 0 ? void 0 : (_payload49$filterCrit = _payload49.filterCriteria) === null || _payload49$filterCrit === void 0 ? void 0 : (_payload49$filterCrit2 = _payload49$filterCrit.isActive) === null || _payload49$filterCrit2 === void 0 ? void 0 : _payload49$filterCrit2.filter(function (el) {
                return el === 0 || el === 1;
              })[0];
              filter["loginStatus"] = isActive ? true : false;
            }
          }
          delete payload.filterCriteria;
          payload = _objectSpread({
            filterCriteria: filter
          }, payload);
          _context30.next = 9;
          return (0, _effects.call)(_services.userBulkSoftDeleteApi, payload);
        case 9:
          response = _context30.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data76 = response.data) === null || _response$data76 === void 0 ? void 0 : _response$data76.code) === 207)) {
            _context30.next = 15;
            break;
          }
          _context30.next = 13;
          return (0, _effects.put)((0, _user.userSuccess)(_user2.actionTypes.BULK_SOFT_DELETE, response === null || response === void 0 ? void 0 : (_response$data77 = response.data) === null || _response$data77 === void 0 ? void 0 : _response$data77.data));
        case 13:
          _context30.next = 17;
          break;
        case 15:
          _context30.next = 17;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.BULK_SOFT_DELETE, response === null || response === void 0 ? void 0 : (_response$data78 = response.data) === null || _response$data78 === void 0 ? void 0 : _response$data78.message));
        case 17:
          _context30.next = 23;
          break;
        case 19:
          _context30.prev = 19;
          _context30.t0 = _context30["catch"](0);
          _context30.next = 23;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.BULK_SOFT_DELETE, _context30.t0));
        case 23:
        case "end":
          return _context30.stop();
      }
    }, _callee29, null, [[0, 19]]);
  })();
}

/**
 * user bulk soft delete restore
 * @param payload
 * @returns api response
 * @description this function used to user bulk soft delete restore.
 */
function userBulkSoftDeleteRestore(_ref30) {
  var payload = _ref30.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee30() {
    var _payload50, _payload50$filterCrit, _payload51, _payload51$filterCrit, _payload52, _payload52$filterCrit, _payload52$filterCrit2, _payload54, _payload54$filterCrit, _payload54$filterCrit2, _response$data79, filter, _payload53, _payload53$filterCrit, _payload55, _payload55$filterCrit, _payload55$filterCrit2, _payload55$filterCrit3, _payload57, _payload57$filterCrit, _payload57$filterCrit2, _payload57$filterCrit3, _payload56, _payload56$filterCrit, _payload56$filterCrit2, _payload58, _payload58$filterCrit, _payload58$filterCrit2, isActive, response, _response$data80, _response$data81;
    return _regeneratorRuntime().wrap(function _callee30$(_context31) {
      while (1) switch (_context31.prev = _context31.next) {
        case 0:
          _context31.prev = 0;
          filter = {}; // Search Text
          if ((_payload50 = payload) !== null && _payload50 !== void 0 && (_payload50$filterCrit = _payload50.filterCriteria) !== null && _payload50$filterCrit !== void 0 && _payload50$filterCrit.searchText) filter["searchText"] = (_payload51 = payload) === null || _payload51 === void 0 ? void 0 : (_payload51$filterCrit = _payload51.filterCriteria) === null || _payload51$filterCrit === void 0 ? void 0 : _payload51$filterCrit.searchText;
          if (((_payload52 = payload) === null || _payload52 === void 0 ? void 0 : (_payload52$filterCrit = _payload52.filterCriteria) === null || _payload52$filterCrit === void 0 ? void 0 : (_payload52$filterCrit2 = _payload52$filterCrit.roleIdList) === null || _payload52$filterCrit2 === void 0 ? void 0 : _payload52$filterCrit2.length) > 0) {
            filter["roleIdList"] = (_payload53 = payload) === null || _payload53 === void 0 ? void 0 : (_payload53$filterCrit = _payload53.filterCriteria) === null || _payload53$filterCrit === void 0 ? void 0 : _payload53$filterCrit.roleIdList;
          }
          if (((_payload54 = payload) === null || _payload54 === void 0 ? void 0 : (_payload54$filterCrit = _payload54.filterCriteria) === null || _payload54$filterCrit === void 0 ? void 0 : (_payload54$filterCrit2 = _payload54$filterCrit.isActive) === null || _payload54$filterCrit2 === void 0 ? void 0 : _payload54$filterCrit2.length) > 0) {
            if (((_payload55 = payload) === null || _payload55 === void 0 ? void 0 : (_payload55$filterCrit = _payload55.filterCriteria) === null || _payload55$filterCrit === void 0 ? void 0 : (_payload55$filterCrit2 = _payload55$filterCrit.isActive) === null || _payload55$filterCrit2 === void 0 ? void 0 : (_payload55$filterCrit3 = _payload55$filterCrit2.filter(function (el) {
              return el === true || el === false;
            })) === null || _payload55$filterCrit3 === void 0 ? void 0 : _payload55$filterCrit3.length) === 1) {
              filter["isActive"] = (_payload56 = payload) === null || _payload56 === void 0 ? void 0 : (_payload56$filterCrit = _payload56.filterCriteria) === null || _payload56$filterCrit === void 0 ? void 0 : (_payload56$filterCrit2 = _payload56$filterCrit.isActive) === null || _payload56$filterCrit2 === void 0 ? void 0 : _payload56$filterCrit2.find(function (el) {
                return el === true || el === false;
              });
            }
            if (((_payload57 = payload) === null || _payload57 === void 0 ? void 0 : (_payload57$filterCrit = _payload57.filterCriteria) === null || _payload57$filterCrit === void 0 ? void 0 : (_payload57$filterCrit2 = _payload57$filterCrit.isActive) === null || _payload57$filterCrit2 === void 0 ? void 0 : (_payload57$filterCrit3 = _payload57$filterCrit2.filter(function (el) {
              return el === 0 || el === 1;
            })) === null || _payload57$filterCrit3 === void 0 ? void 0 : _payload57$filterCrit3.length) === 1) {
              isActive = (_payload58 = payload) === null || _payload58 === void 0 ? void 0 : (_payload58$filterCrit = _payload58.filterCriteria) === null || _payload58$filterCrit === void 0 ? void 0 : (_payload58$filterCrit2 = _payload58$filterCrit.isActive) === null || _payload58$filterCrit2 === void 0 ? void 0 : _payload58$filterCrit2.filter(function (el) {
                return el === 0 || el === 1;
              })[0];
              filter["loginStatus"] = isActive ? true : false;
            }
          }
          delete payload.filterCriteria;
          payload = _objectSpread({
            filterCriteria: filter
          }, payload);
          _context31.next = 9;
          return (0, _effects.call)(_services.userBulkSoftDeleteRestoreApi, payload);
        case 9:
          response = _context31.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data79 = response.data) === null || _response$data79 === void 0 ? void 0 : _response$data79.code) === 207)) {
            _context31.next = 15;
            break;
          }
          _context31.next = 13;
          return (0, _effects.put)((0, _user.userSuccess)(_user2.actionTypes.BULK_SOFT_DELETE_RESTORE, response === null || response === void 0 ? void 0 : (_response$data80 = response.data) === null || _response$data80 === void 0 ? void 0 : _response$data80.data));
        case 13:
          _context31.next = 17;
          break;
        case 15:
          _context31.next = 17;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.BULK_SOFT_DELETE_RESTORE, response === null || response === void 0 ? void 0 : (_response$data81 = response.data) === null || _response$data81 === void 0 ? void 0 : _response$data81.message));
        case 17:
          _context31.next = 23;
          break;
        case 19:
          _context31.prev = 19;
          _context31.t0 = _context31["catch"](0);
          _context31.next = 23;
          return (0, _effects.put)((0, _user.userError)(_user2.actionTypes.BULK_SOFT_DELETE_RESTORE, _context31.t0));
        case 23:
        case "end":
          return _context31.stop();
      }
    }, _callee30, null, [[0, 19]]);
  })();
}
var watchUser = function watchUser() {
  return /*#__PURE__*/_regeneratorRuntime().mark(function watch() {
    return _regeneratorRuntime().wrap(function watch$(_context32) {
      while (1) switch (_context32.prev = _context32.next) {
        case 0:
          _context32.next = 2;
          return (0, _effects.takeLatest)(_user2.actionTypes.USER_ADMIN, userAdminDetails);
        case 2:
          _context32.next = 4;
          return (0, _effects.takeLatest)(_user2.actionTypes.SEND_EMAIL, userSendEmail);
        case 4:
          _context32.next = 6;
          return (0, _effects.takeLatest)(_user2.actionTypes.ADD, userAdd);
        case 6:
          _context32.next = 8;
          return (0, _effects.takeLatest)(_user2.actionTypes.FETCH, userFetch);
        case 8:
          _context32.next = 10;
          return (0, _effects.takeLatest)(_user2.actionTypes.DETAILS, userDetails);
        case 10:
          _context32.next = 12;
          return (0, _effects.takeLatest)(_user2.actionTypes.LIST, userList);
        case 12:
          _context32.next = 14;
          return (0, _effects.takeLatest)(_user2.actionTypes.LIST_TRANSFER, userListTransfer);
        case 14:
          _context32.next = 16;
          return (0, _effects.takeLatest)(_user2.actionTypes.LIST_UNPAGED, userUnpagedList);
        case 16:
          _context32.next = 18;
          return (0, _effects.takeLatest)(_user2.actionTypes.LIST_DELETED_BY_USER, userDeletedByList);
        case 18:
          _context32.next = 20;
          return (0, _effects.takeLatest)(_user2.actionTypes.BRAND_USER_LIST, brandUserList);
        case 20:
          _context32.next = 22;
          return (0, _effects.takeLatest)(_user2.actionTypes.CONTENT_USER_LIST, contentUserList);
        case 22:
          _context32.next = 24;
          return (0, _effects.takeLatest)(_user2.actionTypes.APPLICATION_USER_LIST, applicationUserList);
        case 24:
          _context32.next = 26;
          return (0, _effects.takeLatest)(_user2.actionTypes.DATA_USER_LIST, dataUserList);
        case 26:
          _context32.next = 28;
          return (0, _effects.takeLatest)(_user2.actionTypes.REPORT_USER_LIST, reportUserList);
        case 28:
          _context32.next = 30;
          return (0, _effects.takeLatest)(_user2.actionTypes.SOFT_DELETE, userSoftDelete);
        case 30:
          _context32.next = 32;
          return (0, _effects.takeLatest)(_user2.actionTypes.UPDATE, userUpdate);
        case 32:
          _context32.next = 34;
          return (0, _effects.takeLatest)(_user2.actionTypes.HARD_DELETE, userHardDelete);
        case 34:
          _context32.next = 36;
          return (0, _effects.takeLatest)(_user2.actionTypes.SOFT_RESTORE, userSoftRestore);
        case 36:
          _context32.next = 38;
          return (0, _effects.takeLatest)(_user2.actionTypes.SOFT_DELETE_LIST, userSoftDeletedList);
        case 38:
          _context32.next = 40;
          return (0, _effects.takeLatest)(_user2.actionTypes.UNIQUE_EMAIL, userUniqueEmail);
        case 40:
          _context32.next = 42;
          return (0, _effects.takeLatest)(_user2.actionTypes.BULK_HARD_DELETE, userBulkHardDelete);
        case 42:
          _context32.next = 44;
          return (0, _effects.takeLatest)(_user2.actionTypes.BULK_ACTIVATE, userBulkActivate);
        case 44:
          _context32.next = 46;
          return (0, _effects.takeLatest)(_user2.actionTypes.BULK_DEACTIVATE, userBulkDeactivate);
        case 46:
          _context32.next = 48;
          return (0, _effects.takeLatest)(_user2.actionTypes.ACTIVITIES, userActivities);
        case 48:
          _context32.next = 50;
          return (0, _effects.takeLatest)(_user2.actionTypes.AUTHORIZE_DEVICE, userAuthorizeDevice);
        case 50:
          _context32.next = 52;
          return (0, _effects.takeLatest)(_user2.actionTypes.ACTIVATE_USER, userActivateUser);
        case 52:
          _context32.next = 54;
          return (0, _effects.takeLatest)(_user2.actionTypes.DEACTIVATE_USER, userDeactivateUser);
        case 54:
          _context32.next = 56;
          return (0, _effects.takeLatest)(_user2.actionTypes.TENANT_PERMISSION, userTenantPermission);
        case 56:
          _context32.next = 58;
          return (0, _effects.takeLatest)(_user2.actionTypes.RESET_PASSWORD_COMMON, userResetPasswordCommon);
        case 58:
          _context32.next = 60;
          return (0, _effects.takeLatest)(_user2.actionTypes.BULK_SOFT_DELETE, userBulkSoftDelete);
        case 60:
          _context32.next = 62;
          return (0, _effects.takeLatest)(_user2.actionTypes.BULK_SOFT_DELETE_RESTORE, userBulkSoftDeleteRestore);
        case 62:
        case "end":
          return _context32.stop();
      }
    }, watch);
  });
};
function userSaga() {
  return _regeneratorRuntime().wrap(function userSaga$(_context33) {
    while (1) switch (_context33.prev = _context33.next) {
      case 0:
        _context33.next = 2;
        return (0, _effects.all)([(0, _effects.fork)(watchUser())]);
      case 2:
      case "end":
        return _context33.stop();
    }
  }, _marked2);
}